<dt-table-layout *dtDataLoad="values != null; error: hasError">
  <div header class="cp-filters-form">
    <button mat-raised-button color="primary" (click)="addValue()"
      ><mat-icon>add</mat-icon><ng-container i18n>Wert hinzufügen</ng-container></button
    >
  </div>

  <table
    mat-table
    [dataSource]="values"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="activeSort.active"
    [matSortDirection]="activeSort.direction"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="nameDe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Deutscher Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.de }}</td>
    </ng-container>
    <ng-container matColumnDef="nameEn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Englischer Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.en }}</td>
    </ng-container>
    <ng-container matColumnDef="countTracked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Angezeigt</th>
      <td mat-cell *matCellDef="let row">{{ row.countTracked }}</td>
    </ng-container>
    <ng-container matColumnDef="countAssigned">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Ausgewählt</th>
      <td mat-cell *matCellDef="let row">{{ row.countAssigned }}</td>
    </ng-container>
    <ng-container matColumnDef="countInTop5">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>#Top5</th>
      <td mat-cell *matCellDef="let row">{{ row.countInTop5 }}</td>
    </ng-container>
    <ng-container matColumnDef="averageScore">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>ØScore</th>
      <td mat-cell *matCellDef="let row">{{ row.averageScore | number: '1.2-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetails(row)"></tr>

    <tr class="mat-mdc-row mdc-data-table__row" *matNoDataRow>
      <td class="mat-mdc-cell mdc-data-table__cell" [attr.colspan]="displayedColumns.length" i18n>Es wurden noch keine Werte angelegt.</td>
    </tr>
  </table>

  <dt-table-footer [totalCount]="values.length"></dt-table-footer>
</dt-table-layout>
